import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAbbrobotstudioComponent } from './simple-icons-abbrobotstudio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAbbrobotstudioComponent ],
    exports:      [ SimpleIconsAbbrobotstudioComponent ],
    bootstrap:    []
})
export class SimpleIconsAbbrobotstudioModule {}
